import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <span className="text-2xl font-bold">
                <span className="text-primary-foreground">Social</span>
                <span className="bg-secondary text-secondary-foreground px-2 py-0.5 rounded-md ml-1">Bunkr</span>
              </span>
            </div>
            <p className="text-background/70 mb-6 leading-relaxed">
              Bharat's most affordable stay platform. Experience comfortable living with all-inclusive amenities.
            </p>
            <div className="flex gap-4">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, index) => (
                <motion.a
                  key={index}
                  href="#"
                  whileHover={{ y: -3, scale: 1.1 }}
                  className="w-10 h-10 rounded-full bg-background/10 flex items-center justify-center hover:bg-secondary hover:text-secondary-foreground transition-colors"
                >
                  <Icon size={18} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Quick links">
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-background/70 hover:text-secondary transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/about" className="text-background/70 hover:text-secondary transition-colors">How it Works</Link>
              </li>
              <li>
                <Link to="/guest-search-results" className="text-background/70 hover:text-secondary transition-colors">Destinations</Link>
              </li>
              <li>
                <Link to="/blog" className="text-background/70 hover:text-secondary transition-colors">Blog</Link>
              </li>
              <li>
                <Link to="/careers" className="text-background/70 hover:text-secondary transition-colors">Careers</Link>
              </li>
            </ul>
          </nav>

          {/* Support */}
          <nav aria-label="Support links">
            <h4 className="text-lg font-semibold mb-6">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-background/70 hover:text-secondary transition-colors">Contact Us</Link>
              </li>
              <li>
                <Link to="/faq" className="text-background/70 hover:text-secondary transition-colors">Help Center</Link>
              </li>
              <li>
                <Link to="/faq" className="text-background/70 hover:text-secondary transition-colors">FAQs</Link>
              </li>
              <li>
                <Link to="/terms" className="text-background/70 hover:text-secondary transition-colors">Terms of Service</Link>
              </li>
              <li>
                <Link to="/privacy" className="text-background/70 hover:text-secondary transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-background/70 hover:text-secondary transition-colors">Refund Policy</Link>
              </li>
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-secondary flex-shrink-0 mt-1" />
                <span className="text-background/70">
                  Brundavan colony, Plot no 105, Kokapet, Hyderabad, Telangana 500075
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-secondary flex-shrink-0" />
                <a href="tel:+918008585553" className="text-background/70 hover:text-secondary transition-colors">+91-8008585553</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-secondary flex-shrink-0" />
                <a href="mailto:support@socialbunkr.in" className="text-background/70 hover:text-secondary transition-colors">support@socialbunkr.in</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-background/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-background/60 text-sm">
              © {currentYear} Social Bunkr. All rights reserved.
            </p>
            <nav aria-label="Legal links" className="flex gap-6">
              <Link to="/terms" className="text-background/60 hover:text-secondary text-sm transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="text-background/60 hover:text-secondary text-sm transition-colors">
                Privacy
              </Link>
              <Link to="/privacy" className="text-background/60 hover:text-secondary text-sm transition-colors">
                Cookies
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
